import * as s from "./VideoGuideStyled";
import { SimpleFileViewerModal } from "components/templates/modal/simpleFileViewer/SimpleFileViewerModal";
import { VideoGuideGroup } from "api/interfaces/managerInterface.interface";
import { HelpGuide } from "hook/useHelpGuideApi";
import VideoGuidesList from "./list/VideoGuidesListContainer";
import ReactPlayer from "react-player";
import { extractYouTubeBaseUrl } from "utils/functions";
import ModalTemplate from "components/templates/modal/ModalTemplate";
import CLOSE_ICON from "assets/icons/cross.svg";

type VideoGuidePresenterProps = {
  helpGuidesByGroups: VideoGuideGroup[];
  isYoutubeModal: boolean;
  isPdfModal: boolean;
  selectedGuideItem: HelpGuide | null;
  openYoutube: (item: HelpGuide) => void;
  openPdfModal: (item: HelpGuide) => void;
  closeYoutube: () => void;
  closePdfModal: () => void;
};

export default function VideoGuidePresenter({
  helpGuidesByGroups,
  isYoutubeModal,
  isPdfModal,
  selectedGuideItem,
  openYoutube,
  openPdfModal,
  closeYoutube,
  closePdfModal,
}: VideoGuidePresenterProps) {
  return (
    <>
      <s.Container>
        <s.VideoContainer>
          {(helpGuidesByGroups ?? []).map((item, index) => (
            <VideoGuidesList
              item={item}
              openYoutube={openYoutube}
              openPdfModal={openPdfModal}
              key={`video-list-${index}`}
            />
          ))}
        </s.VideoContainer>
      </s.Container>
      {isYoutubeModal && selectedGuideItem && (
        <ModalTemplate>
          <s.ModalContainer>
            <button
              className="close-button"
              onClick={closeYoutube}
              data-testid="help-video-guides-video-guides-button-close-youtube"
            >
              <img src={CLOSE_ICON} alt="Close" />
            </button>
            <s.VideoPlay>
              <ReactPlayer
                url={extractYouTubeBaseUrl(selectedGuideItem.resourceUrl)}
                controls={true}
                config={{
                  youtube: {
                    playerVars: {
                      autoplay: 0,
                      rel: 0,
                      modestbranding: 1,
                    },
                  },
                }}
              />
            </s.VideoPlay>
          </s.ModalContainer>
        </ModalTemplate>
      )}

      {isPdfModal && selectedGuideItem && (
        <SimpleFileViewerModal
          fileUrl={selectedGuideItem.resourceUrl}
          fileType="pdf"
          onModal={closePdfModal}
        />
      )}
    </>
  );
}
